module.exports = __webpack_public_path__ + "img/11.795f033c.svg";